// @flow
import type { UserGetParam, AllUserFields } from './types'

export const DOMAIN_NAME: string = 'user-service'

export const SESSION_ID_STORAGE_KEY: string = 'foxfordSessionId'

export const AVARAGE_PUPIL_AGE: number = 12

export const PRESCHOOL_AGE: number = 7

export const USER_GET_PARAMS: UserGetParam[] = ['me', 'profile']

export const EXTERNSHIP_PROLONGATION_USER_TAG = 'externship_20_21_prolongation'

export const EXTERNSHIP_USER_TAG = 'externat'

export const DEFAULT_USER: AllUserFields = {
  address: undefined,
  agentProfessionIds: [],
  avatarUrl: '',
  birthday: null,
  bonusAmount: 0,
  cartTemplateId: null,
  coachAgreementAccepted: false,
  coachPaymentScheme: undefined,
  createdAt: '',
  disciplineIds: [],
  disciplines: [],
  email: '',
  emailConfirmed: false,
  externshipCoachAgreementAccepted: false,
  externshipUser: false,
  fakeEmail: false,
  fakeUser: false,
  firstName: 'Учёный',
  fullName: 'Неопознанный Учёный',
  grade: { id: 0, index: 0, name: '' },
  gradeChecked: false,
  hasAccessToMultiDaysStreaks: false,
  hasAccessToAttestationSheets: false,
  hasActivePurchases: false,
  hasBookmarks: false,
  hasChats: false,
  hasReferrals: false,
  id: 0,
  isCoach: false,
  isCustomer: false,
  isElementaryPupil: false,
  isExternshipCoach: false,
  isMiniGroupTeacher: false,
  isGraduate: false,
  isParent: false,
  lastName: 'Неопознанный',
  lastCertificationDate: undefined,
  methodist: false,
  middleName: '',
  onboardingFinished: false,
  parentPhone: '',
  parentPhoneConfirmed: false,
  phone: '',
  phoneConfirmed: false,
  privacy: { publicProfile: false },
  profileEnriched: false,
  recentRegistration: false,
  school: undefined,
  schoolEntryYear: undefined,
  shortName: '',
  skype: null,
  socialNets: [],
  subscribed: false,
  subscriptions: undefined,
  startTeachingYear: undefined,
  tags: [],
  type: 'pupil',
  unconfirmedEmail: null,
  userInfoAttributes: undefined,
}
